import { InputCondition, InputFormatter } from '@tms/directive'

export {
  InputCondition as vInputCondition,
  InputFormatter as vInputFormatter
}
